module.exports = __webpack_public_path__ + "static/media/scb-logo.6f8e2148.png";